import { languagePreferKey } from './elements/Const';

const textMapping = {
  LANGUAGE_PREFERENCE: {
    'zh-TW': '偏好語言',
    en: 'Language Preference',
  },
  FILE_TRANSFORMING: {
    'zh-TW': '檔案處理中',
    en: 'File transforming',
  },
  ERROR: {
    UNKNOWN: {
      'zh-TW': '發生錯誤，請稍後再試',
      en: 'Oops, something wrong! try again later',
    },
    FILE_TOO_LARGE: {
      'zh-TW': '檔案過大，無法順利上傳',
      en: 'File too large for upload',
    },
  },
};

const Multilingual = (textCode, additionalTextMapping = {}, lang = '') => {
  const userDefaultLangs = [lang, ...navigator.languages];

  const languagePrefer = localStorage.getItem(languagePreferKey);
  if (languagePrefer) {
    userDefaultLangs.unshift(languagePrefer);
  }

  const textCodeIndent = textCode.split('.');

  let target = { ...textMapping, ...additionalTextMapping };
  textCodeIndent.forEach((key) => {
    if (!target[key]) {
      console.log(target);
      console.log(key);
      return textCode;
      throw new Error();
    }

    target = target[key];
  });

  // 2024/07/11 由於翻譯資料不完整，先回傳繁體中文以求網站語系統一
  return target['zh-TW'];
  for (let userLang of userDefaultLangs) {
    if (!target[userLang]) {
      continue;
    }

    return target[userLang];
  }
  return target['zh-TW'];
};

export default Multilingual;
